import React from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

function TotalPetsChart() {
  const { dashboardData } = useSelector((state) => state.dashboard);

  if (!dashboardData) return null;

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const lastYearData = months.map((month) => {
    const reqCount = dashboardData.lastYears?.[month]?.count
      ? dashboardData.lastYears?.[month]?.count
      : 0;
    return reqCount;
  });
  const currentYearData = months.map((month) => {
    const reqCount = dashboardData.currentYears?.[month]?.count
      ? dashboardData.currentYears?.[month]?.count
      : 0;
    return reqCount;
  });

  // const lastYearHoverData = months.map((month) => {
  //   const reqCount = dashboardData.lastYears?.[month]?.count
  //     ? dashboardData.lastYears?.[month]?.count
  //     : 0;
  //   return reqCount;
  // });
  // const currentYearData = months.map((month) => {
  //   const reqCount = dashboardData.currentYears?.[month]?.count
  //     ? dashboardData.currentYears?.[month]?.count
  //     : 0;
  //   return reqCount;
  // });

  const chartOptions = {
    chart: {
      type: "line",
      height: 350,
      toolbar: { show: false },
    },
    colors: ["#2E93fA", "#66DA26"],
    stroke: {
      width: [3, 3],
      curve: "smooth",
      dashArray: [0, 5], // solid for this year, dotted for last year
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
      markers: { fillColors: ["#2E93fA", "#66DA26"] },
    },
    xaxis: {
      categories: months,
    },
    yaxis: {
      labels: {
        formatter: (val) => `${val}`,
      },
    },
    fill: {
      gradient: {
        type: "vertical",
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.3,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const month = w.globals.categoryLabels[dataPointIndex];
        let customData = "";
        customData +=
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label" style="margin-right: 5px;">Last Year</span>' +
          "</div>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label" style="margin-right: 5px;">Last 12 months: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          dashboardData?.lastYears?.[month]?.count +
          "</span>" +
          "</div>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label" style="margin-right: 5px;">% Change: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          dashboardData?.lastYears?.[month]?.monthOnMonthGrowth +
          "</span>" +
          "</div>";

        customData +=
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label" style="margin-right: 5px;">Current Year</span>' +
          "</div>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label" style="margin-right: 5px;">Last 12 months: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          dashboardData?.currentYears?.[month]?.count +
          "</span>" +
          "</div>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label" style="margin-right: 5px;">% Change: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          dashboardData?.currentYears?.[month]?.monthOnMonthGrowth +
          "</span>" +
          "</div>";

        // Wrap custom data in a series group
        let seriesGroups = "";
        if (customData) {
          seriesGroups =
            '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex; background-color: #fff; padding: 8px;">' +
            '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000;">' +
            customData +
            "</div>" +
            "</div>";
        }

        return (
          '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; background-color: #EBEBEB; color: #000; padding: 8px; margin: 0;">' +
          month +
          "</div>" +
          seriesGroups
        );
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  };

  const chartSeries = [
    {
      name: "This Year",
      data: currentYearData,
    },
    {
      name: "Last Year",
      data: lastYearData,
    },
  ];

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 0 10px rgba(0,0,0,0.05)",
      }}
    >
      <h3 style={{ marginBottom: "10px" }}>Total Pets</h3>
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={350}
      />
    </div>
  );
}

export default TotalPetsChart;
